<template>
    <div class="job-list-skeleton">
        <ul class="uk-skeleton-grid uk-grid" uk-grid>
            <li v-for="n in 9" :key="n" class="uk-width-1-1 uk-width-1-2@xs uk-width-1-3@l uk-skeleton-item ">
                <span class="uk-skeleton-item-animation"></span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'JobsSkeleton',
};
</script>

<style lang="scss" scoped>
.uk-skeleton-item-animation {
    height: 295px;
}

</style> 
